import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDate = (date?: Date | null) => {
  if (!date) {
    return ''
  }

  return dayjs(date).format('DD/MM/YYYY H:mm')
}

export const formatDatePlusThree = (date?: Date | null) => {
  if (!date) {
    return ''
  }

  return dayjs(date).add(3, 'hour').format('DD/MM/YYYY H:mm')
}

export const formatDateReplaceHour = (date?: Date | null, showDay = true) => {
  if (!date) {
    return ''
  }

  return dayjs(date).add(3, 'hour').format(`${showDay ? 'DD/' : ''}MM/YYYY`)
}

export const formatDateIsoReplaceHour = (date?: Date | null) => {
  if (!date) {
    return ''
  }

  return dayjs(date).add(3, 'hour').format('YYYY-MM-DD')
}

export const formatDateIso = (date?: Date | null) => {
  if (!date) {
    return null
  }

  return dayjs(date).format('YYYY-MM-DD')
}

export const formatterMonthDate = (date: string) => new Intl
  .DateTimeFormat('pt-BR', { month: 'short', year: 'numeric' })
  .format(new Date(`${date}-02`))

export const formatDateUTC = (date: Date | string, format?: string) => {
  if (date instanceof Date) {
    return dayjs.utc(date).format(format || 'DD/MM/YYYY H:mm')
  }

  return dayjs.utc(date).isValid() ? dayjs.utc(date).format(format || 'DD/MM/YYYY H:mm') : date
}

export const isValidDate = (date: Date | string | Dayjs) => dayjs(date).isValid()
